import { ThemeOptions } from '@mui/material/styles';
import { darkColors, breakpoints } from './themeConstants';

const darkTheme: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: darkColors.accent,
      dark: darkColors.accent
    },
    secondary: {
      main: '#424242',
      light: '#757575',
      dark: '#1D212C',
      contrastText: '#424242',
    },
    text: {
      primary: darkColors.text,
    },
    common: {
      black: '#FFFFFF',
      white: '#000000',
    },
    customBackground: {
      main: darkColors.bg,
      light: '#202222',
    },
    customText: {
      main: darkColors.fieldCaption
    },
    customBorder: {
      main: darkColors.border,
      light: darkColors.borderHover,
    },
    textFieldColors: {
      main: darkColors.textFieldText,
      light: darkColors.textFieldBorder,
      dark: darkColors.textFieldLabel,
    }
  },
  typography: {
    fontFamily: [
      'Nunito',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  breakpoints: {
    ...breakpoints
  }
};

export default darkTheme;
